import { AcceptTypesEnum } from "@models/enums/accept-types-enum";
import { AttachmentExtensionEnum } from "@models/enums/attachment-extension-enum";
import { AttachmentTypeEnum } from "@models/enums/attachment-type-enum";
import { DocumentTypeEnum } from "@models/enums/document-type-enum";

export interface AttachmentView {
  label: string;
  accepts: AcceptTypesEnum;
  tipNrId: number | null;
  aneBtAnexo: string | null;
  aneTxExtensaoAnexo: AttachmentExtensionEnum | null;
  aneTxTipoAnexo: AttachmentTypeEnum;
}

export const attachments: AttachmentView[] = [
  {
    tipNrId: null,
    label: 'CPF Frente',
    accepts: AcceptTypesEnum.PDF_IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.CPF_FRENTE,
  },
  {
    tipNrId: null,
    label: 'CPF Verso',
    accepts: AcceptTypesEnum.PDF_IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.CPF_VERSO,
  },
  {
    tipNrId: null,
    label: 'RG Frente',
    accepts: AcceptTypesEnum.PDF_IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.RG_FRENTE,
  },
  {
    tipNrId: null,
    label: 'RG Verso',
    accepts: AcceptTypesEnum.PDF_IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.RG_VERSO,
  },
  {
    tipNrId: null,
    label: 'Passaporte Frente',
    accepts: AcceptTypesEnum.PDF_IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.PASSAPORTE_FRENTE,
  },
  {
    tipNrId: null,
    label: 'Passaporte Verso',
    accepts: AcceptTypesEnum.PDF_IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.PASSAPORTE_VERSO,
  },
  {
    tipNrId: null,
    label: 'RNE Frente',
    accepts: AcceptTypesEnum.PDF_IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.RNE_FRENTE,
  },
  {
    tipNrId: null,
    label: 'RNE Verso',
    accepts: AcceptTypesEnum.PDF_IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.RNE_VERSO,
  },
  {
    tipNrId: null,
    label: 'Foto',
    accepts: AcceptTypesEnum.IMAGE,
    aneBtAnexo: null,
    aneTxExtensaoAnexo: null,
    aneTxTipoAnexo: AttachmentTypeEnum.FOTO,
  },
];

export interface DocumentView {
  label: string;
  mask: string | null;
  placeholder: string;
  docTxDocumento: string | null;
  docTxTipo: DocumentTypeEnum;
}

export const documents = [
  {
    label: 'CPF',
    mask: '000.000.000-00',
    placeholder: 'Ex.: 000.000.000-00',
    docTxDocumento: null,
    docTxOrgaoExpeditor: null,
    docTxTipo: DocumentTypeEnum.CPF,
  },
  {
    label: 'RG',
    mask: null,
    placeholder: 'Ex.: 000000000000000',
    docTxDocumento: null,
    docTxOrgaoExpeditor: null,
    docTxTipo: DocumentTypeEnum.RG,
  },
  {
    label: 'CREF',
    mask: null,
    placeholder: 'Ex.: 000000000000000',
    docTxDocumento: null,
    docTxOrgaoExpeditor: null,
    docTxTipo: DocumentTypeEnum.CREF,
  },
  {
    label: 'Passaporte',
    mask: null,
    placeholder: 'Ex.: 000000000000000',
    docTxDocumento: null,
    docTxOrgaoExpeditor: null,
    docTxTipo: DocumentTypeEnum.Passaporte,
  },
  {
    label: 'RNE',
    mask: null,
    placeholder: 'Ex.: 000000000000000',
    docTxDocumento: null,
    docTxOrgaoExpeditor: null,
    docTxTipo: DocumentTypeEnum.RNE,
  }
]



